export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useUserStore();
  const orgStore = useOrganisationStore();

  const isAuthenticated = authStore.isUserLoggedIn;
  const freelyAccessiblePaths = ["/privacy", "/terms", "/cookies"];
  const normalizedPath = to.path.replace(/\/+$/, "");

  const matchesPath = (targetPath: string) => {
    return (
      normalizedPath === targetPath ||
      normalizedPath.endsWith(targetPath)
    );
  };

  if (matchesPath("/confirm") && !isAuthenticated) {
    return;
  }

  if (isAuthenticated) {
    if (!authStore.user) {
      await authStore.fetchProfileData();
    }

    const isViewerRole = authStore.isViewer;

    if (isViewerRole) {
      if (normalizedPath.startsWith("/action-center")) {
        return navigateTo("/");
      }

      if (matchesPath("/login")) {
        return await navigateTo("/");
      }

      return;
    }

    await orgStore.fetchUsersOrganisations();
    const canUserProceedToHomepage = authStore.canUserProceedToHomepage;
    const canAccessAppNavigation = authStore.canAccessAppNavigation;

    if (!canUserProceedToHomepage && !canAccessAppNavigation) {
      if (matchesPath("/onboarding")) {
        return;
      }

      if (freelyAccessiblePaths.some((path) => matchesPath(path))) {
        return;
      }

      return navigateTo("/onboarding");
    }

    if (matchesPath("/login")) {
      return await navigateTo("/");
    }
  }
});
